import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useMemorizedCacheTag } from '../../../hooks/useMemorizedCacheTag';
import {
  TimetableRelationshipProperties,
  useRoomAvailabilityMatrixQuery,
} from '../../../types/planung-graphql-client-defs';
import { AvailabilityMatrix, Day, TimeGridEntry } from '../../AvailabilityMatrix/AvailabilityMatrix';
import { useTimetableStore } from '../../TimetableGrid/TimetableProvider';
import { TimetableVersionTableType } from '../graphql/types';

type TimetableVersionRoomsMatrixProps = {
  selected: TimetableVersionTableType | null;
  versionUuid?: string | null;
  timeGridEntries: TimeGridEntry[];
  loading: boolean;
  onChange: (availability: TimetableRelationshipProperties) => void;
};

export const TimetableVersionRoomsMatrix = observer(
  ({ versionUuid, selected, timeGridEntries, loading, onChange }: TimetableVersionRoomsMatrixProps) => {
    const context = useMemorizedCacheTag('ROOMS_MATRIX');

    const [{ data, fetching }, execute] = useRoomAvailabilityMatrixQuery({
      variables: {
        versionUuid: versionUuid ?? '',
      },
      context: context,
    });
    const days: Day[] = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

    const hours = timeGridEntries.filter((entry) => !entry.pause);

    const availability = data?.timetableVersions[0].roomsConnection.edges.find((e) => e.node.uuid === selected?.uuid);
    const store = useTimetableStore();

    return (
      <AvailabilityMatrix
        days={days}
        readonly={toJS(store.readonly) || fetching}
        loading={loading}
        hours={hours}
        availability={availability?.properties}
        onChange={(items) => {
          onChange(items);
          execute();
        }}
      />
    );
  },
);
